import {
  API_CALL,
  PLAYER_SWAP_SET_GROUP,
  PLAYER_SWAP_SET_SELECTED,
  PLAYER_SWAP_SET_SWAP
} from '../constants/actionTypes';
import {
  PLAYER_SWAP_MINE,
  PLAYER_SWAP_OTHER,
  PLAYER_SWAP_SELECT_SLATE,
  PLAYER_SWAP_SLATES,
  PLAYER_SWAP_SUBMISSION
} from '../constants/apiTypes';
import {
  getChallenge,
  getMyChallenges,
  getMySlate as getMySlateApi,
  getMySlates as getMySlatesApi,
  submitPlayerSwap
} from '../api/challenges';

export function getMyPlayers() {
  return {
    type: API_CALL,
    api: PLAYER_SWAP_MINE,
    request: getMyChallenges({
      challenge_type_id: 1,
      embed: ['current_user_entries'],
      status: 'active'
    })
  };
}

export function getMySlate(id) {
  return {
    type: API_CALL,
    api: PLAYER_SWAP_SELECT_SLATE,
    request: getMySlateApi(id, { embed: 'games.players,games.teams,current_user_lineups' })
  };
}

export function getMySlates(data = {}) {
  return {
    type: API_CALL,
    api: PLAYER_SWAP_SLATES,
    request: getMySlatesApi({ status: 'active,progressing', ...data })
  };
}

export function getOtherPlayers(challengeId) {
  return {
    type: API_CALL,
    api: PLAYER_SWAP_OTHER,
    request: getChallenge(challengeId, {
      embed: ['current_user_entries', 'games.teams', 'games.players'],
      status: 'active'
    })
  };
}

export function setChallengeGroup(groupId) {
  return {
    type: PLAYER_SWAP_SET_GROUP,
    groupId
  };
}

export function setSelectedPlayer(playerId, positionId, positionAbbr) {
  return {
    type: PLAYER_SWAP_SET_SELECTED,
    playerId,
    positionId,
    positionAbbr
  };
}

export function setSwapPlayer(playerId) {
  return {
    type: PLAYER_SWAP_SET_SWAP,
    playerId
  };
}

export function playerSwapSubmit({
  lineups,
  isTeamSelected,
  isTeamToSwap,
  selectedPositionId,
  selectedPlayerId,
  slateId,
  swapPlayerId,
  swapPositionId
}) {
  const payload = {
    lineups,
    slate_id: slateId
  };

  if (isTeamSelected) {
    payload.team_id = selectedPlayerId;
  } else {
    payload.player_id = selectedPlayerId;
    payload.player_position = selectedPositionId;
  }

  if (isTeamToSwap) {
    payload.replaced_team_id = swapPlayerId;
  } else {
    payload.replaced_player_id = swapPlayerId;
    payload.replaced_player_position = swapPositionId;
  }

  return {
    type: API_CALL,
    api: PLAYER_SWAP_SUBMISSION,
    request: submitPlayerSwap(payload)
  };
}
